// src/components/HeaderWithWallet.jsx

import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import MobileNavigation from './MobileNavigation';
import WalletConnector from './WalletConnector';
import SwitchNetworkModal from './SwitchNetworkModal';  // You'll need to create this component
import { useWallet } from '../context/WalletContext';
import '../styles/header-with-wallet.css';

const HeaderWithWallet = () => {
  const { 
    wallet, 
    connectWallet, 
    disconnectWallet, 
    openWalletModal, 
    closeWalletModal, 
    isWalletModalOpen,
    isSwitchNetworkModalOpen,
    openSwitchNetworkModal,
    closeSwitchNetworkModal,
    switchNetwork,
  } = useWallet();
  
  const [showWalletDropdown, setShowWalletDropdown] = useState(false);
  const walletDropdownRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (walletDropdownRef.current && !walletDropdownRef.current.contains(event.target)) {
        setShowWalletDropdown(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  const formatWalletAddress = (address) => {
    if (!address) return '';
    return address.substring(0, 6) + '...' + address.substring(address.length - 4);
  };
  
  const handleWalletClick = () => {
    if (wallet.connected) {
      setShowWalletDropdown(!showWalletDropdown);
    } else {
      openWalletModal();
    }
  };
  
  const handleDisconnect = () => {
    disconnectWallet();
    setShowWalletDropdown(false);
  };
  
  const getWalletIcon = () => {
    switch (wallet.type?.toLowerCase()) {
      case 'okx':
        return (
          <div className="wallet-icon okx">
            <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="6" fill="#000"/>
              <path d="M23 9H17V15H23V9Z" fill="#8C8C8C"/>
              <path d="M15 9H9V15H15V9Z" fill="#8C8C8C"/>
              <path d="M23 17H17V23H23V17Z" fill="#8C8C8C"/>
              <path d="M15 17H9V23H15V17Z" fill="#8C8C8C"/>
            </svg>
          </div>
        );
      case 'binance':
        return (
          <div className="wallet-icon binance">
            <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="6" fill="#F0B90B"/>
              <path d="M16 7L18.5 9.5L13.5 14.5L11 12L16 7Z" fill="white"/>
              <path d="M19.5 10.5L22 13L13.5 21.5L11 19L19.5 10.5Z" fill="white"/>
              <path d="M10 13L12.5 15.5L10 18L7.5 15.5L10 13Z" fill="white"/>
              <path d="M22 19L24.5 21.5L22 24L19.5 21.5L22 19Z" fill="white"/>
            </svg>
          </div>
        );
      case 'metamask':
        return (
          <div className="wallet-icon metamask">
            <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M27.5933 3L17.6 11.1867L19.4133 6.4L27.5933 3Z" fill="#E17726"/>
              <path d="M4.4 3L14.3067 11.28L12.5867 6.4L4.4 3Z" fill="#E27625"/>
              <path d="M23.8933 21.6133L21.0667 25.9867L26.96 27.6267L28.6667 21.7067L23.8933 21.6133Z" fill="#E27625"/>
              <path d="M3.34666 21.7067L5.04 27.6267L10.9333 25.9867L8.10666 21.6133L3.34666 21.7067Z" fill="#E27625"/>
            </svg>
          </div>
        );
      case 'phantom':
        return (
          <div className="wallet-icon phantom">
            <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="6" fill="#551BF9"/>
              <path d="M23 10H15C12.2 10 10 12.2 10 15C10 17.8 12.2 20 15 20H17V22H21V16H15C14.4 16 14 15.6 14 15C14 14.4 14.4 14 15 14H23V10Z" fill="white"/>
            </svg>
          </div>
        );
      default:
        return (
          <div className="wallet-icon other">
            <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="6" fill="#6366f1"/>
              <path d="M8 16C8 16.5523 7.55228 17 7 17C6.44772 17 6 16.5523 6 16C6 15.4477 6.44772 15 7 15C7.55228 15 8 15.4477 8 16Z" fill="white"/>
              <path d="M17 16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16Z" fill="white"/>
              <path d="M26 16C26 16.5523 25.5523 17 25 17C24.4477 17 24 16.5523 24 16C24 15.4477 24.4477 15 25 15C25.5523 15 26 15.4477 26 16Z" fill="white"/>
            </svg>
          </div>
        );
    }
  };
  
  const getNetworkIcon = () => {
    switch (wallet.network) {
      case 'ethereum':
        return <span className="network-indicator ethereum">ETH</span>;
      case 'bsc':
        return <span className="network-indicator bsc">BSC</span>;
      case 'solana':
        return <span className="network-indicator solana">SOL</span>;
      default:
        return <span className="network-indicator unknown">Unknown</span>;
    }
  };
  
  return (
    <>
      <header>
        <div className="container">
          <nav className="navbar">
            <Logo />
            <div className="nav-links desktop-only">
              <a href="https://rwa.aeronyx.network/#rwa-explanation" className="nav-link">RWA</a>
              <a href="https://rwa.aeronyx.network/#tokenomics" className="nav-link">Tokenomics</a>
              <a href="https://rwa.aeronyx.network/portfolio" className="nav-link">My RWAs</a>
              <a href="https://rwa.aeronyx.network/#products" className="nav-link">Devices</a>
              <a href="https://rwa.aeronyx.network/node#node-application" className="nav-link">Nodes Apply</a>
               <a href="https://rwa.aeronyx.network/dashboard" className="nav-link">Dashboard</a>
              <Link to="/referrals" className="nav-link">Referrals</Link>
              
              {wallet.connected ? (
                <div className="wallet-section" ref={walletDropdownRef}>
                  <button className="wallet-button" onClick={handleWalletClick}>
                    {getWalletIcon()}
                    <div className="wallet-info">
                      <span className="wallet-address">{formatWalletAddress(wallet.address)}</span>
                      {getNetworkIcon()}
                    </div>
                    <span className="dropdown-arrow">▼</span>
                  </button>
                  
                  {showWalletDropdown && (
                    <div className="wallet-dropdown">
                      <div className="wallet-dropdown-header">
                        <div className="wallet-type">{wallet.type} Wallet</div>
                        <div className="wallet-network">{wallet.chainName}</div>
                      </div>
                      
                      <div className="wallet-dropdown-balances">
                        <div className="wallet-dropdown-item balance">
                          <span className="dropdown-label">Native Balance:</span>
                          <span className="balance-value">{wallet.balance} {
                            wallet.network === 'ethereum' ? 'ETH' : 
                            wallet.network === 'bsc' ? 'BNB' : 
                            wallet.network === 'solana' ? 'SOL' : 'Tokens'
                          }</span>
                        </div>
                        <div className="wallet-dropdown-item balance">
                          <span className="dropdown-label">USDT Balance:</span>
                          <span className="balance-value">{wallet.usdtBalance} USDT</span>
                        </div>
                      </div>
                      
                      <div className="wallet-dropdown-divider"></div>
                      
                      {/* Portfolio Links - Added Assets and Orders links */}
                      <Link to="/portfolio" className="wallet-dropdown-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M3 7L12 13L21 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>My Portfolio</span>
                      </Link>
                      
                      <Link to="/portfolio?tab=assets" className="wallet-dropdown-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 2L19 9V22H5V9L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M9 14H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>My Assets</span>
                      </Link>
                      
                      <Link to="/portfolio?tab=orders" className="wallet-dropdown-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M13 3H11C9.89543 3 9 3.89543 9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5C15 3.89543 14.1046 3 13 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M9 12H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M9 16H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>My Orders</span>
                      </Link>
                      
                      <div className="wallet-dropdown-divider"></div>
                      
                      <button className="wallet-dropdown-item" onClick={openSwitchNetworkModal}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 16H4V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 8H20V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M4 12C4 8.13401 7.13401 5 11 5H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M20 12C20 15.866 16.866 19 13 19H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Switch Network</span>
                      </button>
                      
                      <button className="wallet-dropdown-item" onClick={handleDisconnect}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Disconnect</span>
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <button className="btn btn-outline wallet-connect-btn" onClick={openWalletModal}>
                  Connect Wallet
                </button>
              )}
            </div>
            <MobileNavigation />
          </nav>
        </div>
      </header>
      
      {/* Wallet and Network modals */}
      <WalletConnector 
        isOpen={isWalletModalOpen} 
        onClose={closeWalletModal}
        onSuccess={connectWallet}
      />
      
      <SwitchNetworkModal
        isOpen={isSwitchNetworkModalOpen}
        onClose={closeSwitchNetworkModal}
        currentNetwork={wallet.network}
        onSwitch={switchNetwork}
      />
    </>
  );
};

export default HeaderWithWallet;
